import moment from 'moment-timezone';
import {
    NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY,
    NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS,
    NOTIFICATIONS_DISMISS_POPUP,
    NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS,
    NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE,
    NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS,
    NOTIFICATIONS_SHOW_ERROR_POPUP,
    NOTIFICATIONS_SHOW_ERROR_TOAST,
    NOTIFICATIONS_SHOW_INFO_POPUP,
    NOTIFICATIONS_SHOW_INFO_TOAST,
    NOTIFICATIONS_SHOW_SUCCESS_POPUP,
    NOTIFICATIONS_SHOW_SUCCESS_TOAST,
} from './actionTypes/notification-action-types';
import * as tmsEventsApi from '../api/tmsEventsApi';

export function showSuccessToast({ title, message }) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_SUCCESS_TOAST,
            title,
            message,
        });
    };
}
export function showInfoToast({ title, message }) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_INFO_TOAST,
            title,
            message,
        });
    };
}
export function showErrorToast({ title, message }) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_ERROR_TOAST,
            title,
            message,
        });
    };
}

export function showSuccessPopup({
    title,
    message,
    confirmButtonLabel,
    onConfirmClick,
    showCancelButton,
    cancelButtonLabel,
    onCancelClick,
}) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_SUCCESS_POPUP,
            title,
            message,
            confirmButtonLabel,
            onConfirmClick,
            showCancelButton,
            cancelButtonLabel,
            onCancelClick,
        });
    };
}
export function showInfoPopup({
    title,
    message,
    confirmButtonLabel,
    onConfirmClick,
    showCancelButton,
    showConfirmButton,
    showCloseButton,
    noIcon,
    cancelButtonLabel,
    onCancelClick,
    onCloseButtonClick,
    enableDoNotShowAgain,
    reverseButtonOrder,
}) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_INFO_POPUP,
            title,
            message,
            confirmButtonLabel,
            onConfirmClick,
            showCancelButton,
            showConfirmButton,
            showCloseButton,
            noIcon,
            cancelButtonLabel,
            onCancelClick,
            onCloseButtonClick,
            enableDoNotShowAgain,
            reverseButtonOrder,
        });
    };
}
export function showErrorPopup({
    title,
    message,
    error,
    confirmButtonLabel,
    onConfirmClick,
    showCancelButton,
    cancelButtonLabel,
    onCancelClick,
    showSupportLink,
}) {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_SHOW_ERROR_POPUP,
            title,
            message,
            error,
            confirmButtonLabel,
            onConfirmClick,
            showCancelButton,
            cancelButtonLabel,
            onCancelClick,
            showSupportLink,
        });
    };
}

export function dismissNotificationPopUp() {
    return (dispatch) => {
        dispatch({
            type: NOTIFICATIONS_DISMISS_POPUP,
        });
    };
}

export const getPreRegInviteStatus = (userId) => async (dispatch, getState, { mainApi }) => {
    const { preRegInviteStatus } = getState().notifications;

    const key = `pre-reg-invite-poll-time-${userId}`;
    const nextPollUTC = sessionStorage.getItem(key);

    const shouldCallApi = nextPollUTC
        ? moment.utc(nextPollUTC).isSameOrBefore(moment.utc(), 'minutes')
        : !preRegInviteStatus.hasCheckedAtLeastOnce;

    if (!shouldCallApi) {
        return;
    }
    dispatch({ type: NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS });
    try {
        const res = await tmsEventsApi.getPreRegInviteStatus(mainApi, !nextPollUTC);
        if (res.status === 200) {
            sessionStorage.setItem(key, res.data.preRegInvitesNextPollUtc);
        } else if (res.status === 204 && nextPollUTC) {
            sessionStorage.removeItem(key);
        }
        dispatch({ type: NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS, data: res.data });
    } catch (error) {
        dispatch({ type: NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE, error });
        throw error;
    }
};

export const closePreRegInviteNotificationPopUp = () => (dispatch) => {
    dispatch({
        type: NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS,
    });
};

export const updatePreRegNotificationCanDisplayStatus = (canDisplay) => (dispatch) => {
    dispatch({
        type: NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY,
        canDisplayIfDataExists: canDisplay,
    });
};
